import { PDFJS } from './pdf.combined.js';
import * as pdfjsLib from 'pdfjs-dist';

pdfjsLib.GlobalWorkerOptions.workerSrc = new URL('assets/pdf.worker.min.mjs', document.baseURI).toString();

const TARGET_WIDTH = 1704;
const TARGET_HEIGHT = 864;

export async function pdf2svg(data, fileToLoad) {
    const finalSVG = [];
    const sgvElemenstByPage = {};
    let pathsSeen = new Map();
    async function recursion(node, transformParent, pageNum) {
        if (!pathsSeen.has(pageNum)) pathsSeen.set(pageNum, new Set());
        if (node.tagName == 'g' || node.tagName == 'svg') {
            if (node.children.length > 0) {
                for (let i = 0; i < node.children.length; i++) {
                    let transformAttribute;
                    if (node.getAttribute('transform')) {
                        if (transformParent) {
                            transformAttribute = transformParent + ' ' + node.getAttribute('transform');
                        } else {
                            transformAttribute = node.getAttribute('transform');
                        }
                    } else {
                        transformAttribute = transformParent;
                    }
                    recursion(node.children[i], transformAttribute, pageNum);
                }
            }
        } else {
            if (node.tagName === 'path') {
                let path = node.getAttribute('d');
                path = path.replace(/\s/g, '');
                const pagePaths = pathsSeen.get(pageNum);

                if (
                    path.startsWith('M0.160.16L0.16') ||
                    path.startsWith('M00C0') ||
                    path.startsWith('M0-0') ||
                    path.startsWith('M-') ||
                    path.startsWith('M -') ||
                    (!node.getAttribute('fill-rule') && !node.getAttribute('stroke')) ||
                    pagePaths.has(path)
                ) {
                    if (!node.getAttribute('fill-rule') && !node.getAttribute('stroke')) {
                    } else if (pagePaths.has(path)) {
                    }
                } else {
                    pagePaths.add(path);
                    let transformAttribute;
                    if (node.getAttribute('transform')) {
                        transformAttribute = transformParent + ' ' + node.getAttribute('transform');
                    } else {
                        const fill = node.getAttribute('fill');
                        if (!fill || fill == 'none') node.removeAttribute('fill');
                        else node.setAttribute('fill', rgbToHex(fill));

                        const stroke = node.getAttribute('stroke');
                        if (!stroke || stroke == 'none') node.removeAttribute('stroke');
                        else node.setAttribute('stroke', rgbToHex(stroke));
                        transformAttribute = transformParent;
                    }

                    node.setAttribute('transform', transformAttribute);
                    sgvElemenstByPage[pageNum].push(node);
                }
            } else if (node.tagName === 'text') {
            } else {
                let transformAttribute;
                if (node.getAttribute('transform')) {
                    transformAttribute = transformParent + ' ' + node.getAttribute('transform');
                } else {
                    transformAttribute = transformParent;
                }

                node.setAttribute('transform', transformAttribute);
                sgvElemenstByPage[pageNum].push(node);
            }
        }
    }

    await PDFJS.getDocument(data)
        .then(async function (doc) {
            var numPages = doc.numPages;
            var lastPromise = Promise.resolve();
            const arrayBuffer = await fileToLoad.arrayBuffer();

            const pdf = await pdfjsLib.getDocument({
                data: arrayBuffer,
            }).promise;

            var loadPage = function (pageNum) {
                return doc.getPage(pageNum).then(function (page) {
                    var viewport = page.getViewport(1.0 /* scale */);
                    return page.getOperatorList().then(function (opList) {
                        var svgGfx = new PDFJS.SVGGraphics(page.commonObjs, page.objs);
                        svgGfx.embedFonts = true;
                        return svgGfx
                            .getSVG(opList, viewport)
                            .then(async function (svg) {
                                const newSVG = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                                newSVG.setAttribute('viewBox', `0 0 ${TARGET_WIDTH} ${TARGET_HEIGHT}`);
                                sgvElemenstByPage[pageNum] = [];
                                let defsTag = svg.querySelector('defs');
                                defsTag.remove();

                                // Scale imported page content to match the target canvas size
                                const scaleX = TARGET_WIDTH / viewport.width;
                                const scaleY = TARGET_HEIGHT / viewport.height;
                                const initialTransform =
                                    scaleX !== 1 || scaleY !== 1 ? `scale(${scaleX} ${scaleY})` : undefined;

                                await recursion(svg, initialTransform, pageNum);
                                return newSVG;
                            })
                            .then(async newSVG => {
                                for (const element of sgvElemenstByPage[pageNum]) {
                                    const editedElement = editElement(element);
                                    newSVG.append(editedElement);
                                }
                                const page = await pdf.getPage(pageNum);
                                const textContent = await page.getTextContent();
                                const scaleX = TARGET_WIDTH / viewport.width;
                                const scaleY = TARGET_HEIGHT / viewport.height;

                                const svgTextEls = textContent.items.map(item => {
                                    const textItem = item;
                                    const [a, b, , , e, f] = textItem.transform;
                                    const fontSize = Math.hypot(a, b);
                                    const x = e * scaleX;
                                    const y = (viewport.height - f) * scaleY;
                                    const textNode = document.createElementNS('http://www.w3.org/2000/svg', 'text');
                                    const textContent = escapeXml(textItem.str);
                                    if (!textContent || textContent.length == 0) return;
                                    textNode.setAttribute('x', x.toFixed(2));
                                    textNode.setAttribute('y', y.toFixed(2));
                                    textNode.setAttribute('fill', '#ffffff');
                                    textNode.setAttribute('stroke', '#000000');
                                    textNode.setAttribute('stroke-width', 0);

                                    textNode.setAttribute('font-size', `${Math.round(fontSize * scaleY).toFixed(2)}`);
                                    textNode.setAttribute('font-family', 'Inter');
                                    textNode.textContent = textContent;
                                    return textNode;
                                });

                                svgTextEls.forEach(element => {
                                    if (!element) return;
                                    const editedElement = editElement(element);
                                    newSVG.append(editedElement);
                                });

                                return newSVG;
                            })
                            .then(newSVG => {
                                var s = new XMLSerializer();
                                var svgString = s.serializeToString(newSVG);
                                finalSVG.push([svgString, pageNum]);
                            });
                    });
                });
            };

            for (var i = 1; i <= numPages; i++) {
                lastPromise = lastPromise.then(loadPage.bind(null, i));
            }
            return lastPromise;
        })
        .catch(err => console.error('Error: ' + err));
    return finalSVG;
}

function editElement(element) {
    if (element.tagName === 'image') {
        return;
    }
    return element;
}

function rgbToHex(rgb) {
    const [r, g, b] = rgb?.match(/\d+/g)?.map(Number);
    const colorString = [r, g, b]?.map(x => x?.toString(16)?.padStart(2, '0') ?? '00')?.join('');
    return '#' + colorString;
}

function escapeXml(str) {
    return str
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&apos;');
}

function convertPxToFont(px, unit = 'rem', base = 16) {
    const targetUnit = unit.toLowerCase();

    switch (targetUnit) {
        case 'rem':
        case 'em':
            return `${px / base}${targetUnit}`;
        case '%':
            return `${(px / base) * 100}%`;
        default:
            throw new Error("Invalid unit. Please use 'rem', 'em', or '%'.");
    }
}
